import {
  AuthorGetResDTO,
  AuthorPostReqDTO,
  AuthorPutReqDTO,
} from "../api/author-dto.js";

/**
 * Author 모델 정의
 * 프론트엔드에서 사용할 Author 타입
 */
export interface Author {
  id: string;
  authorName: string;
  authorEmail?: string;
  authorInsta?: string;
  authorLinkedin?: string;
  numOfArticles: number;
  createdAt: string;
  updatedAt: string;
}

/**
 * DTO를 Author 모델로 변환하는 함수
 */
export const toAuthor = (dto: AuthorGetResDTO): Author => {
  return {
    id: dto.id,
    authorName: dto.authorName,
    authorEmail: dto.authorEmail,
    authorInsta: dto.authorInsta,
    authorLinkedin: dto.authorLinkedin,
    numOfArticles: dto.numOfArticles,
    createdAt: dto.createdAt,
    updatedAt: dto.updatedAt,
  };
};

/**
 * Author 모델을 POST 요청 DTO로 변환하는 함수
 */
export const toAuthorPostReqDTO = (
  author: Omit<Author, "id" | "createdAt" | "updatedAt">,
): AuthorPostReqDTO => {
  return {
    authorName: author.authorName,
    authorEmail: author.authorEmail,
    authorInsta: author.authorInsta,
    authorLinkedin: author.authorLinkedin,
    numOfArticles: author.numOfArticles,
  };
};

/**
 * Author 모델을 PUT 요청 DTO로 변환하는 함수
 */
export const toAuthorPutReqDTO = (
  author: Partial<Author> & { id: string },
): AuthorPutReqDTO => {
  return {
    id: author.id,
    authorName: author.authorName,
    authorEmail: author.authorEmail,
    authorInsta: author.authorInsta,
    authorLinkedin: author.authorLinkedin,
    numOfArticles: author.numOfArticles,
    updatedAt: author.updatedAt || new Date().toISOString(),
  };
};
